module.exports = __webpack_public_path__ + "img/BT_home.23985a4d.svg";